import React, { PureComponent } from 'react'
import {
  node, shape, object, func,
} from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import FormField from '@active/react-ui/FormField'
import { Locale, withI18n } from '@active/react-utils/i18n'

import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'
import CardNumberInfo from '../CardNumberInfo'
import imgMap from '../imgs/imgMap'

import './CreditCardDetail.scss'

class CreditCardDetail extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    fields: shape({
      address: object.isRequired,
    }).isRequired,
    children: node.isRequired,
    i18n: func.isRequired,
  }

  render() {
    const {
      children, paymentMethod, fields, i18n,
    } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)

    const subFields = {
      ...fields,
      expirationDate: info.getSummaryData(i18n),
    }

    return (
      <div className="checkout-payments checkout__payment-detail checkout__credit-card-detail">
        <Form
          horizontal
          initialValues={subFields}
          className="form--vertical checkout__payment-detail--form checkout__credit-card-detail--form"
        >
          <FormGroup name="cardHolderName">
            <FormLabel><Locale id="passport.lib.components.common.holder.name" /></FormLabel>
            <FormStaticField
              className="checkout__credit-card-detail--card-name"
            />
          </FormGroup>
          <FormGroup name="last4Digits">
            <FormLabel><Locale id="passport.lib.components.common.card.number" /></FormLabel>
            <FormField
              as={CardNumberInfo}
              paymentMethod={paymentMethod}
            />
          </FormGroup>
          <FormGroup name="expirationDate">
            <FormLabel><Locale id="passport.lib.components.common.expiration.date" /></FormLabel>
            <FormStaticField />
          </FormGroup>
          {children}
        </Form>
      </div>
    )
  }
}

export default withI18n(CreditCardDetail)

const defaultIcon = [imgMap.CreditCard, 'credit-card']
export {
  defaultIcon,
}
